import { ReviewStructure } from '../../reviews-section';

const CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-kitchen';

export const REVIEWS_DATA: ReviewStructure[] = [
  {
    imagesAlt: 'Review 1',
    images: [`${CDN_PATH}/reviews/review-1-1.jpg/review-1-1.jpg`],
    bigImages: [`new-kitchen/reviews/big/review-1-1.jpg/review-1-1.jpg`],
    rating: 5,
    text:
      'Хочется отметить идеальную работу продавца-консультанта Ирины Карась, проект кухни был выполнен на\u00A0высшем уровне. Так как у\u00A0нас затянулся ремонт, проект ждал нас очень долго. Сама кухня превзошла все ожидания\u00A0\u2014 стильная, качественная, уютная. Ирина учла все наши пожелания, помогла советом, когда мы\u00A0не\u00A0могли прийти к\u00A0единому мнению. Все дополнительные вопросы решались в\u00A0одно мгновение. Благодарю прекрасного специалиста Ирину, за\u00A0её\u00A0профессионализм, ответственность, знания, навыки, опыт, уважительность и\u00A0человечность. Примите благодарность за\u00A0результат вашего труда!',
    date: '2024 год',
    store: 'Люберцы',
  },
  {
    imagesAlt: 'Review 2',
    images: [`${CDN_PATH}/reviews/review-2-1.jpg/review-2-1.jpg`],
    bigImages: [`new-kitchen/reviews/big/review-2-1.jpg/review-2-1.jpg`],
    rating: 5,
    text:
      'Меня всё устроило. Менеджер компетентен, все вопросы решались сразу. Выражаю благодарность специалисту по\u00A0продажам Наргизе.',
    date: '2024 год',
    store: 'Химки',
  },
  {
    imagesAlt: 'Review 3',
    images: [
      `${CDN_PATH}/reviews/review-3-1.jpg/review-3-1.jpg`,
      `${CDN_PATH}/reviews/review-3-2.jpg/review-3-2.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-3-1.jpg/review-3-1.jpg`,
      `new-kitchen/reviews/big/review-3-2.jpg/review-3-2.jpg`,
    ],
    rating: 4.5,
    text:
      'Благодарность по\u00A0сборке кухни мастеру Анатолию и\u00A0замерщику Ивану\u00A0\u2014 все очень профессионально и\u00A0с\u00A0индивидуальным подходом.',
    date: '2024 год',
    store: 'Южные врата',
  },
  {
    imagesAlt: 'Review 4',
    images: [
      `${CDN_PATH}/reviews/review-7-1.jpg/review-7-1.jpg`,
      `${CDN_PATH}/reviews/review-7-2.jpg/review-7-2.jpg`,
      `${CDN_PATH}/reviews/review-7-3.jpg/review-7-3.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-7-1.jpg/review-7-1.jpg`,
      `new-kitchen/reviews/big/review-7-2.jpg/review-7-2.jpg`,
      `new-kitchen/reviews/big/review-7-3.jpg/review-7-3.jpg`,
    ],
    rating: 5,
    text:
      'Всё очень понравилось! Спасибо большое за\u00A0консультацию и\u00A0подбор кухни! Всё профессионально и\u00A0качественно! Отдельная благодарность сборщику кухни Павлу Киселёву! Профессионал своего дела, всё делает аккуратно, точно! Собрал кухню и\u00A0подключил технику отлично!!! После сборки всё убрал! Мы\u00A0очень довольны сотрудниками магазина за\u00A0подбор кухни и\u00A0мастером по\u00A0сборке!!! 🙏🙏🙏',
    date: '2024 год',
    store: 'Климовск',
  },
  {
    imagesAlt: 'Review 5',
    images: [`${CDN_PATH}/reviews/review-8-1.jpg/review-8-1.jpg`],
    bigImages: [`new-kitchen/reviews/big/review-8-1.jpg/review-8-1.jpg`],
    rating: 4.5,
    text: 'Благодарю проектировщика кухонь Соболевскую Наталью за\u00A0отличный проект и\u00A0поддержку!',
    date: '2024 год',
    store: 'Воронеж',
  },
  {
    imagesAlt: 'Review 6',
    images: [
      `${CDN_PATH}/reviews/review-9-1.jpg/review-9-1.jpg`,
      `${CDN_PATH}/reviews/review-9-2.jpg/review-9-2.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-9-1.jpg/review-9-1.jpg`,
      `new-kitchen/reviews/big/review-9-2.jpg/review-9-2.jpg`,
    ],
    rating: 5,
    text: 'Специалисту, который составлял проект, отдельное человеческое СПАСИБО!! Молодец!!!',
    date: '2024 год',
    store: 'Киевское шоссе',
  },
  {
    imagesAlt: 'Review 7',
    images: [
      `${CDN_PATH}/reviews/review-10-1.jpg/review-10-1.jpg`,
      `${CDN_PATH}/reviews/review-10-2.jpg/review-10-2.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-10-1.jpg/review-10-1.jpg`,
      `new-kitchen/reviews/big/review-10-2.jpg/review-10-2.jpg`,
    ],
    rating: 5,
    text:
      'Спасибо огромное проектировщику кухонь\u00A0\u2014 Константину. Грамотный специалист, ведущий проект от\u00A0начала и\u00A0до\u00A0его завершения, всегда внимательный, отзывчивый, интересующий возникающими вопросами и\u00A0помогающий в\u00A0их\u00A0решении. Уточнил все нюансы, сопоставил результат замерщика с\u00A0пожеланиями заказчика, внёс грамотные коррективы в\u00A0проект кухни. И\u00A0вот результат. Заказчик очень доволен и\u00A0выражает огромную благодарность за\u00A0проведенную работу и\u00A0сборку необыкновенной красоты кухни \u00ABНевель\u00BB.',
    date: '2024 год',
    store: 'Жуковский',
  },
  {
    imagesAlt: 'Review 8',
    images: [
      `${CDN_PATH}/reviews/review-11-1.jpg/review-11-1.jpg`,
      `${CDN_PATH}/reviews/review-11-2.jpg/review-11-2.jpg`,
      `${CDN_PATH}/reviews/review-11-3.jpg/review-11-3.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-11-1.jpg/review-11-1.jpg`,
      `new-kitchen/reviews/big/review-11-2.jpg/review-11-2.jpg`,
      `new-kitchen/reviews/big/review-11-3.jpg/review-11-3.jpg`,
    ],
    rating: 5,
    text:
      'Добрый день! Хочется выразить огромную благодарность Артёму Копейкину\u00A0\u2014 специалисту по\u00A0продаже проектов Лемана ПРО (г. Троицк, МО). Он\u00A0очень помог нам и\u00A0с\u00A0проектированием кухни и\u00A0с\u00A0оформлением заказа и\u00A0с\u00A0оплатой в\u00A0день, когда у\u00A0него был выходной. Для этого он\u00A0даже оформил удалённый доступ. Очень компетентный и\u00A0отзывчивый сотрудник. Профессионал своего дела и\u00A0доброжелательный человек.',
    date: '2024 год',
    store: 'Новая Рига',
  },
  {
    imagesAlt: 'Review 9',
    images: [
      `${CDN_PATH}/reviews/review-12-1.jpg/review-12-1.jpg`,
      `${CDN_PATH}/reviews/review-12-2.jpg/review-12-2.jpg`,
      `${CDN_PATH}/reviews/review-12-3.jpg/review-12-3.jpg`,
      `${CDN_PATH}/reviews/review-12-4.jpg/review-12-4.jpg`,
      `${CDN_PATH}/reviews/review-12-5.jpg/review-12-5.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-12-1.jpg/review-12-1.jpg`,
      `new-kitchen/reviews/big/review-12-2.jpg/review-12-2.jpg`,
      `new-kitchen/reviews/big/review-12-3.jpg/review-12-3.jpg`,
      `new-kitchen/reviews/big/review-12-4.jpg/review-12-4.jpg`,
      `new-kitchen/reviews/big/review-12-5.jpg/review-12-5.jpg`,
    ],
    rating: 5,
    text:
      'Всё очень понравилось, специалист Екатерина сделала идеальный проект, в\u00A0процессе показала некоторые детали кухни на\u00A0стенде в\u00A0магазине, она предложила очень грамотные решения. Ребята доставили кухню в\u00A0целости, помогли всё проверить. Сборщик Максим сделал свою работу качественно и\u00A0быстро, всё рассказал. В\u00A0общем я\u00A0осталась в\u00A0полном восторге, ещё и\u00A0ребята в\u00A0магазине помогли оформить расрочку, что значительно упростило мне жизнь! Спасибо большое за\u00A0качество и\u00A0профессиональных сотрудников!',
    date: '2024 год',
    store: 'Пушкино',
  },
  {
    imagesAlt: 'Review 10',
    images: [
      `${CDN_PATH}/reviews/review-13-1.jpg/review-13-1.jpg`,
      `${CDN_PATH}/reviews/review-13-2.jpg/review-13-2.jpg`,
      `${CDN_PATH}/reviews/review-13-3.jpg/review-13-3.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-13-1.jpg/review-13-1.jpg`,
      `new-kitchen/reviews/big/review-13-2.jpg/review-13-2.jpg`,
      `new-kitchen/reviews/big/review-13-3.jpg/review-13-3.jpg`,
    ],
    rating: 5,
    text:
      'Екатерина\u00A0\u2014 отличный, вежливый специалист, всегда предупреждала о\u00A0каких либо изменениях в\u00A0наличии комплектующих проекта. Вместе с\u00A0тем, смогли подобрать отличный вариант по\u00A0соотношению цена/качество/скорость.',
    date: '2024 год',
    store: 'Рязанский проспект',
  },
  {
    imagesAlt: 'Review 11',
    images: [
      `${CDN_PATH}/reviews/review-4-1.jpg/review-4-1.jpg`,
      `${CDN_PATH}/reviews/review-4-2.jpg/review-4-2.jpg`,
    ],
    bigImages: [
      `new-kitchen/reviews/big/review-4-1.jpg/review-4-1.jpg`,
      `new-kitchen/reviews/big/review-4-2.jpg/review-4-2.jpg`,
    ],
    rating: 5,
    text:
      'В\u00A0целом очень рада что ваш магазин рядом с\u00A0моей квартирой и\u00A0я\u00A0смогла сделать ремонт благодаря вам. Спасибо большое! Желаю успеха развития и\u00A0побольше ассортимент, особенно заменить ИКЕА. Тронэс от\u00A0икеа у\u00A0вас нашла дешево очень рада.',
    date: '2024 год',
    store: 'Зеленоград',
  },
  {
    imagesAlt: 'Review 12',
    images: [`${CDN_PATH}/reviews/review-5-1.jpg/review-5-1.jpg`],
    bigImages: [`new-kitchen/reviews/big/review-5-1.jpg/review-5-1.jpg`],
    rating: 5,
    text:
      'Большое спасибо Наталье за\u00A0подбор элементов для кухни (магазин на\u00A0Каширском шоссе). Четко и\u00A0правильно помогла подобрать детали для нестандартного помещения.',
    date: '2024 год',
    store: 'Варшавское шоссе',
  },
  {
    imagesAlt: 'Review 13',
    images: [`${CDN_PATH}/reviews/review-6-1.jpg/review-6-1.jpg`],
    bigImages: [`new-kitchen/reviews/big/review-6-1.jpg/review-6-1.jpg`],
    rating: 4.5,
    text:
      'Делала проект кухни в\u00A0Лемана ПРО Домодедово, хочется поблагодарить Истомину Татьяну, специалиста проектных продаж. Помогла с\u00A0выбором кухни и\u00A0проектированием. Очень вежливый сотрудник, профессионал своего дела.',
    date: '2024 год',
    store: 'Домодедово',
  },
];
